import './toggle.scss';
import React from 'react';
import { Switch, Tooltip } from 'antd';
import CustomIcon, { IconType } from '../custom-icon/custom-icon';
import { TooltipDisableReason } from '../tooltip-disable-message/tooltip-disable-reason';
import { DisableReasons } from 'src/utils/enums';

interface ToggleProps {
    label?: string;
    anotherClassName?: string;
    value: boolean;
    disableReason?: DisableReasons | string;
    missingPermissions?: boolean;
    withIcon?: boolean;
    inactiveStateIcon?: boolean;
    title?: string;
    inactiveLabel?: string;
    onChange: (val: boolean) => void;
    disabled?: boolean;
}
export const Toggle: React.FC<ToggleProps> = ({ label, anotherClassName, value, disableReason,
    missingPermissions, withIcon, inactiveStateIcon, inactiveLabel,
    title, onChange, disabled }) => {

    const isDisabled = disabled ?? !!disableReason;
    return <div className={`toggle-wrapper ${anotherClassName || ''}`}>
        {label && <div className={'toggle-name'}>{value ? label : (inactiveLabel ?? label)}</div>}
        {inactiveStateIcon && <span className={'alert'}>
            <Tooltip placement="bottomRight" title={title}
                overlayClassName={'item-alert'} color="black" showArrow={false}>
                <CustomIcon className={`toggle-buttons-state`} type={IconType.INACTIVE_ALERT} size={16} />
            </Tooltip>
        </span>}
        <TooltipDisableReason disableReason={disableReason} missingPermissions={missingPermissions}>
            <div>
                <Switch
                    className={`toggle-input ${withIcon || 'icon-less'}`}
                    checked={value}
                    onChange={onChange}
                    disabled={isDisabled} />
            </div>
        </TooltipDisableReason>
    </div>;
};